export const PAGE_TYPE = {
  SIGN_UP: 'Inscription',
  PROFILE: 'Profils',
  PURCHASES: 'Achats',
  AUTH: 'oauth',
  CART: 'Panier',
  CHECKOUT: 'Checkout',
  SEARCH: 'Recherche',
  ACCOUNT: 'Mon compte',
  HOME: 'Home',
  PRODUCT_PAGE: 'Page produit',
  SEARCH_RESULT: 'Résultats de recherche',
  CONTACT_FAQ: 'Contact/FAQ',
  NEWS: 'Article',
  ADHERENTS: 'Adhérents',
  SHOPPING_LISTS: 'Listes',
  ORDERS: 'Commandes',
  CGU: 'CGU',
  MISC: 'Divers',
}

export const PAGE_ANALYTICS_INFO = {
  HOME: { name: 'Home', category: PAGE_TYPE.HOME },
  SEARCH_RESULTS: { name: 'Résultats de recherche', category: PAGE_TYPE.SEARCH },
  PRODUCT_PAGE: { name: 'Détails page produit', category: PAGE_TYPE.PRODUCT_PAGE },
  ADHERENTS_ACCOUNT: { name: 'Contrats de vente', category: PAGE_TYPE.ACCOUNT },
  ADHERENTS_LIST: { name: 'Listing des adhérents', category: PAGE_TYPE.ADHERENTS },
  ADHERENT_SHOPPING_LISTS: { name: "Listes d'un adhérent", category: PAGE_TYPE.ADHERENTS },
  ADHERENT_DETAILS: { name: "Profil d'un adhérent", category: PAGE_TYPE.ADHERENTS },
  ADHERENT_MEMBERSHIP_ANALYTICS: { name: `Statistiques de navigation d'un adhérent`, category: PAGE_TYPE.ADHERENTS },
  ADHERENT_ORDERS: { name: "Commandes d'un adhérent", category: PAGE_TYPE.ADHERENTS },
  TECHNICIAN_SHOPPING_LISTS: { name: 'Listes du technicien', category: PAGE_TYPE.SHOPPING_LISTS },
  LIST_DETAILS: { name: "Détails d'une liste", category: PAGE_TYPE.SHOPPING_LISTS },
  SEND_SHOPPING_LIST: { name: "Envoi d'une liste", category: PAGE_TYPE.SHOPPING_LISTS },
  ORDER_DETAILS: { name: "Détail d'une commande", category: PAGE_TYPE.ORDERS },
  ORDERS: { name: 'Liste de toutes les commandes', category: PAGE_TYPE.ORDERS },
  CHECKOUT: { name: 'Commande en cours', category: PAGE_TYPE.CHECKOUT },
  SMAG_SSO: { name: 'SMAG SSO', category: PAGE_TYPE.AUTH },
  OAUTH_CALLBACK: { name: 'Auth Callback', category: PAGE_TYPE.AUTH },
  AUTH: { name: 'oauth', category: PAGE_TYPE.AUTH },
  OAUTH_SILENT_CALLBACK: { name: 'oauth silent callback', category: PAGE_TYPE.AUTH },
  CGU: { name: 'Accepter CGU', category: PAGE_TYPE.CGU },
  NOT_FOUND: { name: 'page non trouvée', category: PAGE_TYPE.MISC },
}
